import React from 'react';
import { render } from 'react-dom';
import 'babel-polyfill';
import 'intl';
import { browserHistory } from 'react-router';
import injectTapEventPlugin from 'react-tap-event-plugin';
import createStore from './app/store';
import App from './app/App';
import './styles/main.scss';
import './styles/external/all';// This is the axa web-toolkit js
import locales from '../dist/locales.json';


injectTapEventPlugin(); // need this for material ui

const { store, syncedHistory } = createStore(browserHistory);

const rootElement = window.document.getElementById('app');

if (rootElement) {
  render(
    <App store={store} history={syncedHistory} locales={locales} />,
    rootElement
  );
}



// WEBPACK FOOTER //
// ./src/client.js